<template>
  <div class="flex justify-between w-full">
    <div>
      <h5>
        {{ item.description }}
        <span v-if="variantsAmount === 0">- &euro; {{ itemPrice }}</span>
      </h5>
    </div>
    <b-button variant="link" @click.prevent="$emit('close-modal')">
      <i class="fas fa-times"></i>
    </b-button>
  </div>
</template>
<script>
import {decimalToPriceString} from "@/util/decimalToPriceString";

export default {
  name: "ItemModalAddToCartHeader",
  props: {
    item: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    showPrices: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    itemPrice() {
      if (this.item.priceGross) {
        return decimalToPriceString({value: this.item.priceNettExcVAT});
      }
      return 0;
    },
      variantsAmount() {
      if (this.item.variants !== undefined) {
        return this.item.variants.length  
      }
      return null;
    }
  },
};
</script>
